const NewsroomScreen = () => {
  
    return (
       <p>Newsroom Screen here</p>
    )
}

export default NewsroomScreen